/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function () {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	// jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
	// 	if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
	// 		jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
	// 	} else {
	// 		jQuery(this).wrap("<div class='responsive-embed'/>");
	// 	}
	// });

	jQuery('.home-boxes').packery({
		// options
		itemSelector: '.home-box',
		gutter: 30
	  });
	  jQuery('.ivmf-all-bio').isotope({
		// options
		itemSelector: '.bio-card',
		layoutMode: 'fitRows',
		getSortData: {
			sortByName: '[data-sortByName]'
		},
		sortBy : 'sortByName',
		sortAscending: true,
		filter: '*:not(".hide-all-1")',
		gutter: 30

	  });
	  jQuery('.phases-results').isotope({
		// options
		itemSelector: '.card.phases-filter'
	  });
	  jQuery('.filter-button-group').on( 'click', 'button', function() {
		var filterValue = jQuery(this).attr('data-filter');
		jQuery('.ivmf-all-bio').isotope({ filter: filterValue });
	  });
	  jQuery('.filter-button-group').on( 'click', 'button', function() {
		var filterValue = jQuery(this).attr('data-filter');
		jQuery('.phases-results').isotope({ filter: filterValue });
	  });
	  jQuery('.filters-select').on( 'change', function() {
		var filterValue = this.value;
		jQuery('.phases-results').isotope({ filter: filterValue });
	  });

	  // get publication articles based on filters and sort criteria
	  getPosts = function(e) {
		jQuery('#article-list .archive-post').addClass('archive-post--loading');
		if(e!=null && e.currentTarget.id==="loadMore") {
		  jQuery("#pageid").val(parseInt(jQuery("#pageid").val())+1);
		} else {
		  jQuery("#pageid").val(1);
		}
		jQuery.ajax({
			type: "POST",
			url: ajaxurl,
			data: jQuery("#pubfilter").serialize(), // serializes the form's elements.
			success: function(data)
			{

			   if(e!=null && e.currentTarget.id==="loadMore"){

				   jQuery("#article-list").append(data);
			     }  else{
				   jQuery("#article-list").html(data); // show response from the php script.
				}
			   if(jQuery("#noLoadMore").length>0){
				 jQuery('#loadMore').hide();
			   }else{
				 jQuery('#loadMore').show();
			   jQuery('#article-order').change(getPosts);
			   }
		jQuery('#article-list .archive-post').removeClass('archive-post--loading');
			}
		  });


		if(e!=null && e.currentTarget.id==="apply") {

		}
		if(e!=null && (e.currentTarget.id==="apply" || e.currentTarget.id==="loadMore"))
		  e.preventDefault();
	  };

	  // sort criteria for publication
	  jQuery('#article-order').change(getPosts);

	  // filter criteria for publication
		if(jQuery("#filterBtn").length==0 || jQuery("#filterBtn").is(':visible')==false)
		jQuery('.publication-filter').click(getPosts);

		// apply filter criteria for publication mobile version
		jQuery('#apply').click(getPosts);

		// load more posts
	  jQuery('#loadMore').click(getPosts);




	  jQuery("#loadMoreResults").click(function(e) {
		url = jQuery(this).attr("data-url");
		jQuery.get( url, function( data ) {
			jQuery('#ivmf-content').append(jQuery(data).find('#ivmf-content').html());
			if( jQuery(data).find('#loadMoreResults').length==0)
			  jQuery("#loadMoreResults").hide();
			else
			  jQuery("#loadMoreResults").attr("data-url", jQuery(data).find('#loadMoreResults').attr("data-url"));
		  });
		e.preventDefault();
	  });









jQuery('#clear-checks').on('click', function(e){
	jQuery('#pubfilter input:checkbox').prop('checked', false);
	jQuery('#article-list .archive-post').addClass('archive-post--loading');

});
jQuery('#top-search-toggle').keypress(function(e){
	var keyPressed = (event.keyCode ? event.keyCode : event.which);
	if(keyPressed == '13'){
		jQuery('#searchModal').foundation('open');
	}
});

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var sa = getParameterByName('sa');

if(sa != null){
	jQuery( "#"+sa ).delay(20).prop( "checked", true );
	jQuery('#filter').submit();
}
	});
// end on ready



// show-details
jQuery('body').on('click','.toggle-text-plus',function(){
		jQuery(this).parents('.item-details').toggleClass('show-details');
});

jQuery('body').on('keydown','.toggle-text-plus',function(){
	var keyPressed = (event.keyCode ? event.keyCode : event.which);
	if(keyPressed == '13'){
		jQuery(this).parents('.item-details').toggleClass('show-details');
	}
});

jQuery('#filter').submit(function(){
	console.log(filter);
	var filter = jQuery('#filter');
	jQuery.ajax({
		url:filter.attr('action'),
		data:filter.serialize(), // form data
		type:filter.attr('method'), // POST
		beforeSend:function(xhr){
			filter.find('button').text('Processing...'); // changing the button label
		},
		success:function(data){
			filter.find('button').text('Apply filter'); // changing the button label back
			jQuery('#response').html(data); // insert data
			console.log(data);
			jQuery('.checklist').removeClass('loading-check');
		}
	});
	return false;
});

var tId;
jQuery('#filter input[type="checkbox"]').change(function(){
    clearTimeout(tId);
    if (('#filter input[type="checkbox"]:checked').length>0){
		jQuery('.checklist').addClass('loading-check');
		jQuery('#filter').find('button').text('Processing...');
      tId=setTimeout(function(){
        jQuery('#filter').submit();
      },1500);
    }
});
